// extracted by mini-css-extract-plugin
export var paginationContainer = "_90-0";